import { type AllowedStrategyType } from '@/shared/utils/strategies';
import StrategyBpsInput from './StrategyBpsInput';
import StrategyPriceInput from './StrategyPriceInput';

type SpreadInputsProps = {
  strategyType: AllowedStrategyType;
  minBuy?: string;
  maxBuy?: string;
  minSell?: string;
  maxSell?: string;
  setMinBuy: (value: string) => void;
  setMaxBuy: (value: string) => void;
  setMinSell: (value: string) => void;
  setMaxSell: (value: string) => void;
  errors: {
    minBuy?: boolean;
    maxBuy?: boolean;
    minSell?: boolean;
    maxSell?: boolean;
  };
  disabled?: boolean;
};

export default function SpreadInputs({
  strategyType,
  minBuy,
  maxBuy,
  minSell,
  maxSell,
  setMinBuy,
  setMaxBuy,
  setMinSell,
  setMaxSell,
  errors,
  disabled,
}: SpreadInputsProps) {
  const Input = strategyType === 'INVENTORY_BASED' ? StrategyPriceInput : StrategyBpsInput;
  const labelValue = strategyType === 'INVENTORY_BASED' ? 'Price' : 'Offset (bps)';

  return (
    <div className="grid grid-cols-2 gap-2">
      <Input
        label={
          <>
            Min. <span className="text-cf-green-3">Buy</span> {labelValue}
          </>
        }
        value={minBuy}
        onChange={(value) => {
          setMinBuy(value ?? undefined);
        }}
        disabled={disabled}
        error={errors.minBuy ? '' : undefined}
      />
      <Input
        label={
          <>
            Max. <span className="text-cf-green-3">Buy</span> {labelValue}
          </>
        }
        value={maxBuy}
        onChange={(value) => {
          setMaxBuy(value ?? undefined);
        }}
        disabled={disabled}
        error={errors.maxBuy ? '' : undefined}
      />
      <Input
        label={
          <>
            Min. <span className="text-cf-red-2">Sell</span> {labelValue}
          </>
        }
        value={minSell}
        onChange={(value) => {
          setMinSell(value ?? undefined);
        }}
        disabled={disabled}
        error={errors.minSell ? '' : undefined}
      />
      <Input
        label={
          <>
            Max. <span className="text-cf-red-2">Sell</span> {labelValue}
          </>
        }
        value={maxSell}
        onChange={(value) => {
          setMaxSell(value ?? undefined);
        }}
        disabled={disabled}
        error={errors.maxSell ? '' : undefined}
      />
    </div>
  );
}
